import { formatCurrency } from 'utils/formatters/formatCurrency';

export const getPaymentTotalPaidText = ({
  totalAmount,
  orderPaymentAmount,
}: {
  totalAmount: number;
  orderPaymentAmount?: number | string;
}) => {
  return orderPaymentAmount && Number(orderPaymentAmount) !== totalAmount
    ? `${formatCurrency(Number(orderPaymentAmount))} of ${formatCurrency(totalAmount)} bulk payment`
    : formatCurrency(totalAmount);
};
